// 플랫폼 분기 추상화 모듈.
// PWA(웹) vs Capacitor(네이티브) 환경을 구분해 알림/카메라/저장소 등 후속 분기 모듈의 기준이 된다.
// 호출부(features/pages)는 `Capacitor.isNativePlatform()` 같은 분기를 직접 두지 말고 본 모듈을 사용한다.
// 자세한 규칙은 docs/architecture.md §3, docs/ui-guidelines.md §4.

export type AppPlatform = "web" | "android" | "ios";

// Capacitor 네이티브 환경 여부 판정.
// Capacitor 가 window.Capacitor 객체를 주입하므로 본 변수 존재 여부로 안전하게 판별한다.
// 의존성 없이 동작하도록 동적 접근 + 옵셔널 체인 사용.
export function detectAppPlatform(): AppPlatform {
  const cap = (globalThis as { Capacitor?: { getPlatform?: () => string } }).Capacitor;
  const platform = cap?.getPlatform?.();
  if (platform === "android") {
    return "android";
  }
  if (platform === "ios") {
    return "ios";
  }
  return "web";
}

// 네이티브 앱(Capacitor 환경) 여부.
// PWA 전용 UX(예: 홈화면 설치 유도 배너) 노출 제어 등 호출부에서 자주 쓰는 단축형 헬퍼다.
export function isNativeApp(): boolean {
  return detectAppPlatform() !== "web";
}
